import { render, staticRenderFns } from "./CompareVersionsHeader.vue?vue&type=template&id=7ea7d614"
import script from "./CompareVersionsHeader.vue?vue&type=script&lang=js"
export * from "./CompareVersionsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports